/**
 * @module selectors/scope
 */

/**
 * @type {String}
 */
export default ':scope'
